// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2dy_W","signatureButtonsRight":"ModalSign_signatureButtonsRight__1ulLi"};